// Currency utilities — all internal state is in SAR, display converts via fixed rates.
import { toArabicIndicDigits } from "@/lib/digits";

export const CURRENCIES = {
  SAR: { code: "SAR", symbol_ar: "ر.س", symbol_en: "SAR", rate: 1,       name_ar: "الريال السعودي",   name_en: "Saudi Riyal", flag: "🇸🇦" },
  USD: { code: "USD", symbol_ar: "$",   symbol_en: "$",   rate: 0.267,   name_ar: "الدولار الأمريكي", name_en: "US Dollar",   flag: "🇺🇸" },
  EUR: { code: "EUR", symbol_ar: "€",   symbol_en: "€",   rate: 0.245,   name_ar: "اليورو",           name_en: "Euro",        flag: "🇪🇺" },
  AED: { code: "AED", symbol_ar: "د.إ", symbol_en: "AED", rate: 0.978,   name_ar: "الدرهم الإماراتي", name_en: "UAE Dirham",  flag: "🇦🇪" },
  KWD: { code: "KWD", symbol_ar: "د.ك", symbol_en: "KWD", rate: 0.082,   name_ar: "الدينار الكويتي",  name_en: "Kuwaiti Dinar", flag: "🇰🇼" },
  QAR: { code: "QAR", symbol_ar: "ر.ق", symbol_en: "QAR", rate: 0.971,   name_ar: "الريال القطري",    name_en: "Qatari Riyal", flag: "🇶🇦" },
  BHD: { code: "BHD", symbol_ar: "د.ب", symbol_en: "BHD", rate: 0.100,   name_ar: "الدينار البحريني", name_en: "Bahraini Dinar", flag: "🇧🇭" },
  EGP: { code: "EGP", symbol_ar: "ج.م", symbol_en: "EGP", rate: 12.85,   name_ar: "الجنيه المصري",    name_en: "Egyptian Pound", flag: "🇪🇬" },
};

export const convertFromSar = (sarAmount, targetCode) => {
  const c = CURRENCIES[targetCode] || CURRENCIES.SAR;
  return sarAmount * c.rate;
};

export const formatMoney = (sarAmount, currencyCode = "SAR", lang = "ar", digits = "en") => {
  const c = CURRENCIES[currencyCode] || CURRENCIES.SAR;
  const converted = sarAmount * c.rate;
  const decimals = ["KWD", "BHD"].includes(currencyCode) ? 2 : 0;
  const rounded = Math.round(converted * Math.pow(10, decimals)) / Math.pow(10, decimals);
  const formatted = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(rounded);
  const value = digits === "ar" ? toArabicIndicDigits(formatted) : formatted;
  const symbol = lang === "ar" ? c.symbol_ar : c.symbol_en;
  return { value, symbol, code: c.code };
};
